module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAQAAABLCVATAAAAyUlEQVR4Ae3OAUZEURSA4ZMEIggQRdAQCAgJLSBCQEBASBjQAoJZRtAmkghAAIEQA5GqBJPqK6BxBt59FwPvX8Dnj66uaWffetRn26dHq1GXnjdwEzVZMgTv1mqYBXdgZKuGmXMNvu023T+Jicy4ABw2ZR7Qj5QB4KyEkSnHgPMyJlH2/IBLs2XM6zhl0wjcmi9jBlYMAX09z+DeYiETf/mnXsCT5RZMoviw0YbJ1JeddkymDtoxmTqKJrnKTElpvoJJ1Gl0dU25X72CLN9s8T5VAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/satisfaction.png
// module id = jaHE
// module chunks = 1